import _ from 'lodash'
import {api} from '../api';
import {RELATION_LIST_FETCHED,
    RELATION_MODEL_LOADED,
    RELATION_MODEL_UPDATED_ON_SERVER,
    RELATION_MODEL_UPDATED_BY_FORM,
    RELATION_ADDRESS_MODEL_UPDATED_BY_FORM,
    RELATION_ADDRESS_MODEL_UPDATED_ON_SERVER,
    RELATION_CONTACT_MODEL_UPDATED_BY_FORM,
    RELATION_CONTACT_MODEL_UPDATED_ON_SERVER,
    RELATION_PRICING_MODEL_UPDATED_BY_FORM,
    RELATION_PRICING_MODEL_UPDATED_ON_SERVER,
    RELATION_ADDRESS_MODEL_SELECTED,
    RELATION_CONTACT_MODEL_SELECTED,
    RELATION_PRICING_MODEL_SELECTED,
    RELATION_MODEL_ADDRESS_CREATED,
    RELATION_MODEL_ADDRESS_UPDATED,
    RELATION_MODEL_CONTACT_CREATED,
    RELATION_MODEL_CONTACT_UPDATED,
    RELATION_MODEL_PRICING_CREATED,
    RELATION_MODEL_PRICING_UPDATED,
    RELATION_MODEL_PRICING_DELETED,
    UNMAPPED_WOO_CUSTOMER_LOADED,
    RELATION_MODEL_NOTE_DELETED,
    RELATION_MODEL_NOTE_CREATED,
    RELATION_MODEL_NOTE_UPDATED
} from './types';

export const fetchRelation = (jwt,params) => (dispatch) => {
    return api.relation.fetch(jwt, params).then(res => {
        dispatch({
            type: RELATION_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const loadRelationById = (jwt, id, type) => (dispatch) => {
    if (_.isInteger(parseInt(id))) {
        return api.relation.loadModel(jwt, id).then( res => {
            dispatch({
                type: RELATION_MODEL_LOADED,
                payload: res.data.data
            })
            return res;
        }).catch( err => {
            throw err
        })
    } else {
        dispatch({
            type: RELATION_MODEL_LOADED,
            payload: {
                id: null,
                type: type,
                company_name: "",
                account: "",
                status: "Active",
                given_name: "",
                family_name: "",
                email: "",
                phone: "",
                qualified_name: "",
                display_name: "",
                check_name: "",
                currency: "CAD",
                woo_id: null,
                acct_id: null,
                tax_id: 0,
                term_id: 0,
                trace: [],
                special_pricings: [],
                contacts: [],
                addresses: []
            }
        })
    }
}

export const updateRelationModelInStore = (field, value) => {
    return ({
        type: RELATION_MODEL_UPDATED_BY_FORM,
        payload: {field, value}
    })
}

export const updateOrCreateRelation = (jwt, model) => (dispatch) => {
    if (model.id) {
        //PUT update
        return api.relation.update(jwt, model).then(res => {
            dispatch({
                type: RELATION_MODEL_UPDATED_ON_SERVER,
                payload: model
            })
        }).catch(err => {throw err});
    } else {
        //Create NEW, set store once updated
        return api.relation.create(jwt, model).then(res => {
            const {data} = res.data;
            data.addresses = [];
            data.contacts = [];
            data.special_pricings = [];
            data.orders = [];
            dispatch({
                type: RELATION_MODEL_LOADED,
                payload: data
            })
            return res;
        }).catch(err => {throw err})
    }
}

export const noteCruded = (noteId, note, crud = 'create') => {
    if (crud === 'create') {
        return {
            type: RELATION_MODEL_NOTE_CREATED,
            payload: note
        }
    }
    if (crud === 'update') {
        return {
            type: RELATION_MODEL_NOTE_UPDATED,
            payload: note
        }
    }
    if (crud === 'delete') {
        return {
            type: RELATION_MODEL_NOTE_DELETED,
            payload: noteId
        }
    }
}

export const setAddressModelInStore = (address, relationId) => {
    if (!address.id) {
        address = {
            id: '',
            relation_id: relationId,
            label: '',
            status: 'Active',
            first_name: '',
            last_name: '',
            company: '',
            address_1: '',
            address_2: '',
            city: '',
            state: '',
            postcode: '',
            country: '',
            email: '',
            phone: '',
            rep_id: null
        }
    }
    return ({
        type: RELATION_ADDRESS_MODEL_SELECTED,
        payload: address
    });
}
export const updateAddressModelInStore = (field, value) => {
    return ({
        type: RELATION_ADDRESS_MODEL_UPDATED_BY_FORM,
        payload: {field, value}
    })
}
export const updateOrCreateAddress = (jwt, model) => (dispatch) => {
    if (model.id) {
        //PUT update
        return api.relation.address.update(jwt, model).then(res => {
            dispatch({
                type: RELATION_ADDRESS_MODEL_UPDATED_ON_SERVER,
                payload: model
            })
            dispatch({
                type: RELATION_MODEL_ADDRESS_UPDATED,
                payload: model
            })
            return res;
        }).catch(err => {throw err});
    } else {
        //Create NEW, set store once updated
        return api.relation.address.create(jwt, model).then(res => {
            dispatch({
                type: RELATION_ADDRESS_MODEL_SELECTED,
                payload: res.data.data
            })
            dispatch({
                type: RELATION_MODEL_ADDRESS_CREATED,
                payload: res.data.data
            })
            return res;
        }).catch(err => {throw err})
    }
}

export const loadUnmappedWooCustomers = (jwt) => (dispatch) => {
    return api.relation.loadWooUnmapped(jwt).then(res => {
        const {data} = res.data;
        data.unshift({key: '0', value: '0', text: 'Not Mapped'});
        dispatch({
            type: UNMAPPED_WOO_CUSTOMER_LOADED,
            payload: data
        });
    }).catch(err => {throw err});
}

export const setContactModelInStore = (contact, relationId) => {
    if (!contact.id) {
        contact = {
            id: '',
            relation_id: relationId,
            status: 'Active',
            name: '',
            phone: '',
            fax: '',
            email: '',
            title: '',
            dpartment: ''
        }
    }
    return ({
        type: RELATION_CONTACT_MODEL_SELECTED,
        payload: contact
    });
}
export const updateContactModelInStore = (field, value) => {
    return ({
        type: RELATION_CONTACT_MODEL_UPDATED_BY_FORM,
        payload: {field, value}
    })
}
export const updateOrCreateContact = (jwt, model) => (dispatch) => {
    if (model.id) {
        //PUT update
        return api.relation.contact.update(jwt, model).then(res => {
            dispatch({
                type: RELATION_CONTACT_MODEL_UPDATED_ON_SERVER,
                payload: model
            })
            dispatch({
                type: RELATION_MODEL_CONTACT_UPDATED,
                payload: model
            })
            return res;
        }).catch(err => {throw err});
    } else {
        //Create NEW, set store once updated
        return api.relation.contact.create(jwt, model).then(res => {
            dispatch({
                type: RELATION_CONTACT_MODEL_SELECTED,
                payload: res.data.data
            })
            dispatch({
                type: RELATION_MODEL_CONTACT_CREATED,
                payload: res.data.data
            })
            return res;
        }).catch(err => {throw err})
    }
}

export const setPricingModelInStore = (pricing, relationId) => {
    if (!pricing.id) {
        pricing = {
            id: '',
            sku: '',
            name: '',
            cost: 0,
            selling: 0,
            pivot: {
                relation_id: relationId,
                inventory_id: '',
                special_sku: '',
                special_name: '',
                special_price: 0
            }
        }
    }

    return ({
        type: RELATION_PRICING_MODEL_SELECTED,
        payload: pricing
    });
}

export const updatePricingModelInStore = (field, value, isPivot) => {
    return ({
        type: RELATION_PRICING_MODEL_UPDATED_BY_FORM,
        payload: {
            updated: {field, value},
            isPivot
        }
    })
}
export const updateOrCreatePricing = (jwt, model) => (dispatch) => {
    if (model.id) {
        //PUT update
        return api.relation.pricing.update(jwt, model.pivot).then(res => {
            dispatch({
                type: RELATION_PRICING_MODEL_UPDATED_ON_SERVER,
                payload: model
            })
            dispatch({
                type: RELATION_MODEL_PRICING_UPDATED,
                payload: model
            })
            return res;
        }).catch(err => {throw err});
    } else {
        //Create NEW, set store once updated
        return api.relation.pricing.create(jwt, model.pivot).then(res => {
            model.id = model.pivot.inventory_id;
            dispatch({
                type: RELATION_PRICING_MODEL_SELECTED,
                payload: model
            })
            dispatch({
                type: RELATION_MODEL_PRICING_CREATED,
                payload: model
            })
            return res;
        }).catch(err => {throw err})
    }
}

export const deletePricing = (jwt, relationId, inventoryId) => (dispatch) => {
    return api.relation.pricing.delete(jwt, relationId, inventoryId).then( res => {
        dispatch({
            type: RELATION_MODEL_PRICING_DELETED,
            payload: inventoryId
        });
        return res;
    }).catch( err => {throw err})
}



// WEBPACK FOOTER //
// ./src/actions/relation.js